"use client"

import {
  BlockRenderer,
  Container,
  ContentText,
  CustomBreadcrumbs,
  ImageTextBlock,
  TopBanner,
} from "ui"
import { findProperty, getBreadCrumbs } from "utils"
import TzabarGraph from "./TzabarGraph"

type Props = {
  data: any
  locale: string
}
function Tzabar({ data, locale }: Props) {
  const { selfObject, parents } = getBreadCrumbs(data, locale)

  const components = {
    topBanner: TopBanner,
    contentText: ContentText,
    pieGraphBlock: TzabarGraph,
    imageTextBlock1: ImageTextBlock,
  }
  const blocks = findProperty(data.page, "blocks")?.blocks || []
  const hasBanner = blocks?.some(
    (block: any) => block.blockType === "topBanner" || block.blockType === "HeaderWithHeroAndText",
  )

  return (
    <>
      <Container>
        <CustomBreadcrumbs current={selfObject} parents={parents} />
      </Container>
      {blocks?.map((block: any, index: number) => {
        let additionalProps = {}
        if (block.blockType === "contentText") {
          additionalProps = {
            hasBanner,
          }
        }
        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            components={components}
            props={additionalProps}
          />
        )
      })}
    </>
  )
}
export default Tzabar
